import { ChangeDetectorRef, ElementRef, Injectable, QueryList } from "@angular/core";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { ITEM_REVENUE_CATEGORY } from "src/app/helpers/item-revenue.helper";
import { ModuleLayout } from "src/app/helpers/module-categories.helper";
import { CompanyLensOptions } from "src/app/models/company-lens-options.model";
import { CompanyLenses } from "src/app/models/company-lenses.model";
import { CartManagerService } from "./cart-manager.service";
import { LocalStorageService } from "./local-storage.service";

@Injectable({
    providedIn: 'root'
  })

  /* This service helps manage common ordering flows across modules */

  export class OrderManagerService {

    private readonly N_LENS_WARN_TITLE = 'Lens Selection';
    private readonly N_LENS_WARN_MSG = 'You must select a lens type to continue.';

    constructor (private _notificationService: ToastrService,
                 private _localStorageService: LocalStorageService,
                 private _router: Router,
                 private _cartManagerService: CartManagerService) {}

    verifyLensSelection(isEditMode: boolean) {
      const cartItem = this._cartManagerService.getTempCartItem();
      const selectedLens = cartItem?.itemDetails.find(id => id.itemType == ITEM_REVENUE_CATEGORY.lenses);
      if (!selectedLens) {
        this._notificationService.warning(this.N_LENS_WARN_MSG, this.N_LENS_WARN_TITLE);
      }
      else {
        const queryParams = isEditMode ? {'isEditMode' : isEditMode} : {};
        this._router.navigate(['/lens-selection/options'], { queryParams: queryParams });
      }
    }

    removeLensItemDetail() {
      this._cartManagerService.removeTempCartItemDetailByItemType(ITEM_REVENUE_CATEGORY.lenses);
      this._router.navigate(['/lens-selection']);
    }

    navigateToProdSelection() {
      const cartItem = this._cartManagerService.getTempCartItem();
      if (cartItem) {
        let modlayout = ModuleLayout.find(m => m.category == cartItem.itemCategory);
        if (modlayout) {
          this._router.navigate([modlayout.link]);
        }
        else {
          this._router.navigate(['/dashboard']);
        }
      }
    }

    preSelectLensItems(lenses: QueryList<ElementRef<any>>, isEditMode: boolean, companyLenses: CompanyLenses[]) {
      if (isEditMode) {
        const editedCartItem = this._localStorageService.getEditItem();
        let lens = editedCartItem?.itemDetails.find(id => id.itemType == ITEM_REVENUE_CATEGORY.lenses);
        if (lens) {
          const companyLens = companyLenses.find(cl => cl.itemId == lens?.itemListId);
          const selectedLens = lenses.find(i => i.nativeElement.id == companyLens?.lensId);
          if (selectedLens) {
            (selectedLens.nativeElement as HTMLElement).click();
          }
        }
      }
      else {
        const cartItems = this._cartManagerService.getTempCartItem();
        if (cartItems) {
          let lens = cartItems?.itemDetails.find(id => id.itemType == ITEM_REVENUE_CATEGORY.lenses);
          if (lens) {
            const selectedLens = lenses.find(i => i.nativeElement.id == lens?.id);
            if (selectedLens) {
              (selectedLens.nativeElement as HTMLElement).click();
            }
          }
        }
      }
    }

  preSelectLensOptionItems(options: QueryList<ElementRef<any>>, isEditMode: boolean, companyLensOptions: CompanyLensOptions[]) {
    if (isEditMode) {
      const editedCartItem = this._localStorageService.getEditItem();
      let lensOptions = editedCartItem?.itemDetails.filter(id => id.itemType == ITEM_REVENUE_CATEGORY.lensTreatment);
      if (lensOptions) {
        lensOptions?.forEach((option) => {
          const companyLensOption = companyLensOptions.find(cl => cl.itemId == option.itemListId);
          const selectedLensOption = options.find(i => i.nativeElement.id == companyLensOption?.lensOptionId);
          if (selectedLensOption) {
            (selectedLensOption.nativeElement as HTMLElement).click();
            return;
          }
        });
      }
    }
    else {
      const cartItems = this._cartManagerService.getTempCartItem();
      if (cartItems) {
        let lensOptions = cartItems?.itemDetails.filter(id => id.itemType == ITEM_REVENUE_CATEGORY.lensTreatment);
        if (lensOptions) {
          lensOptions?.forEach((option) => {
            const selectedOption = options.find(i => i.nativeElement.id == option.id);
            if (selectedOption) {
              (selectedOption.nativeElement as HTMLElement).click();
              return;
            }
          });
        }
      }
    }
  }
}

